import { ETabs } from 'src/components/Tabs';
import { TFieldsAssetArgs } from 'src/features/Assets/SingleAsset/SingleAsset.types';
import { ConfigType } from 'src/graphql';
import { TFieldsTemplateUnion } from 'src/utils/assetsFields/assetsFields.types';

const Load = ({ configType }: TFieldsAssetArgs): TFieldsTemplateUnion[] => {
  return [
    {
      name: 'name',
      type: 'text',
      label: 'labels.ASSET_NAME',
      defaultValue: 'Load',
      formView: ETabs.BASIC,
    },
    {
      name: 'dailyLoadProfile',
      type: 'file',
      label: 'labels.UPLOAD_PROFILE',
      tooltipText: 'tooltips.UPLOAD_LOAD_PROFILE_INFO',
      formView: ETabs.BASIC,
      exclude: configType === ConfigType.CanaryNetwork,
    },
  ];
};

export default Load;
